'use es6';

import { Record } from 'immutable';
import { VARIANT_TYPES } from '../constants/base';
const DEFAULTS = {
  abStatus: '',
  id: '',
  name: '',
  pageId: '',
  // only used for sending the content.id while making api requests to choose a winner or rerun a variation because `analyticsPageId` is not same as `content.id` for legacy pages
  url: ''
};
export default class Variation extends Record(DEFAULTS) {
  static fromJS(data) {
    const {
      abStatus,
      analyticsPageId,
      id,
      name,
      url
    } = data;
    return new Variation({
      abStatus,
      id: analyticsPageId || String(id),
      name,
      pageId: id,
      url: abStatus === 'master' ? `${url}?hsNotRandom=true` : url
    });
  }

  static fromMABVariation(data) {
    const {
      mabMaster,
      id,
      name,
      url
    } = data;
    return new Variation({
      abStatus: mabMaster ? VARIANT_TYPES.get('MASTER') : VARIANT_TYPES.get('VARIANT'),
      id,
      name,
      pageId: id,
      url
    });
  }

}